import { render } from "./VideoPlayer.vue?vue&type=template&id=0ac2e69d"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/BinaryFlow/components/Product/Gallery/VideoPlayer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ac2e69d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ac2e69d', __exports__)) {
    api.reload('0ac2e69d', __exports__)
  }
  
  module.hot.accept("./VideoPlayer.vue?vue&type=template&id=0ac2e69d", () => {
    api.rerender('0ac2e69d', render)
  })

}


export default __exports__